var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0802 8.74789L9.18772 16.0233C8.34333 16.9146 7.19811 17.4153 6.00397 17.4153C4.80983 17.4153 3.6646 16.9146 2.82022 16.0233C1.97583 15.132 1.50146 13.9232 1.50146 12.6627C1.50146 11.4022 1.97583 10.1934 2.82022 9.30206L9.71272 2.02664C10.2756 1.43245 11.0391 1.09863 11.8352 1.09863C12.6313 1.09863 13.3948 1.43245 13.9577 2.02664C14.5206 2.62084 14.8369 3.42674 14.8369 4.26706C14.8369 5.10738 14.5206 5.91328 13.9577 6.50748L7.05772 13.7829C6.77626 14.08 6.39451 14.2469 5.99647 14.2469C5.59842 14.2469 5.21668 14.08 4.93522 13.7829C4.65376 13.4858 4.49563 13.0828 4.49563 12.6627C4.49563 12.2425 4.65376 11.8396 4.93522 11.5425L11.3027 4.82914",
    stroke: "#40A6DE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.2f77b094671913f261ab79d4dd836c1b.svg";
export { ForwardRef as ReactComponent };